const migrateFromV1ToV2 = (data) => {
  console.log("migrating to v2")
  return data
}
const migrateFromV2ToV3 = (data) => {
  console.log("migrating to v3")
  return {
    data: {}
  }
}
const migrateFromV3ToV4 = (data) => {
  console.log("migrating to v4")
  if (data.data["Projects:columnVisibility"] !== undefined && JSON.parse(data.data["Projects:columnVisibility"]).options) {
    let columnVisibility = JSON.parse(data.data["Projects:columnVisibility"])
    delete columnVisibility.options
    data.data["Projects:columnVisibility"] = JSON.stringify(columnVisibility)
  }
  if (data.data["Projects:columnOrder"] !== undefined) {
    data.data["Projects:columnOrder"] = JSON.stringify(JSON.parse(data.data["Projects:columnOrder"]).filter(item => item !== "options"))
  }
  delete data.data.version
  return data
}
const migrateFromV4ToV5 = (data) => {
  console.log("migrating to v5")
  delete data.data["equipment:columnVisibility"]
  delete data.data["Equipment:columnVisibility"]
  return data
}
const migrateFromV5ToV6 = (data) => {
  console.log("migrating to v6")
  const prefixes = ["TW Reporter", "Reporter", "[object Object]", "equipment", "Equipment"]
  Object.keys(data.data).forEach(key => {
    const hasMatchingPrefix = prefixes.some(prefix => key.startsWith(prefix))
    if (hasMatchingPrefix) {
      delete data.data[key]
    }
  })
  return data
}
const migrateFromV6ToV7 = (data) => {
  console.log("migrating to v7")
  const prefixes = ["Projects:columnOrder"]
  Object.keys(data.data).forEach(key => {
    const hasMatchingPrefix = prefixes.some(prefix => key.startsWith(prefix))
    if (hasMatchingPrefix) {
      delete data.data[key]
    }
  })
  return data
}
const migrateFromV7ToV8 = (data) => {
  console.log("migrating to v8")
  const prefixes = ["Projects:columnOrder"]
  Object.keys(data.data).forEach(key => {
    const hasMatchingPrefix = prefixes.some(prefix => key.startsWith(prefix))
    if (hasMatchingPrefix) {
      let columnOrder = data.data[key]
      if (columnOrder) {
        columnOrder = JSON.parse(columnOrder)
        if (!columnOrder.includes('user_note')) {
          columnOrder.push('user_note')
        }
        const updatedColumnOrder = JSON.stringify(columnOrder)
        data.data[key] = updatedColumnOrder
      }
    }
  })
  return data
}

const migrateFromV8ToV9 = (data) => {
  console.log("migrating to v9")
  delete data.data["Projects:columnVisibility"]
  return data
}

const migrateFromV9ToV10 = (data) => {
  console.log("migrating to v10")
  delete data.data["Projects:columnOrder"]
  return data
}

const migrateData = (data) => {
  if (!data) return data

  let version = data.data?.version || 1
  console.log("current version", version)

  if (version === 1) {
    data = migrateFromV1ToV2(data)
    version = 2
  }
  if (version === 2) {
    data = migrateFromV2ToV3(data)
    version = 3
  }
  if (version === 3) {
    data = migrateFromV3ToV4(data)
    version = 4
  }
  if (version === 4) {
    data = migrateFromV4ToV5(data)
    version = 5
  }
  if (version === 5) {
    data = migrateFromV5ToV6(data)
    version = 6
  }
  if (version === 6) {
    data = migrateFromV6ToV7(data)
    version = 7
  }
  if (version === 7) {
    data = migrateFromV7ToV8(data)
    version = 8
  }
  if (version === 8) {
    data = migrateFromV8ToV9(data)
    version = 9
  }
  if (version === 9) {
    data = migrateFromV9ToV10(data)
    version = 10
  }

  return data
}

export { migrateData }